import { getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import { grey100, grey400 } from 'ext-ui/style/colors'
import variables from 'src/style/variables.json'
import { css } from 'styled-components'

export default css`
  &.UtilityToolbarSearch {
    display: flex;
    flex-direction: column;
    padding: 0px ${variables.units['base-unit-7']}px;

    &.noHeader {
      padding: 0px ${variables.units['base-unit-7']}px 0px 0px;
    }

    & .container {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      height: ${variables.units['base-unit-10']}px;
      padding: 0px ${variables.units['base-unit-4']}px;
      border-radius: 6px;
      border: 1px solid transparent;

      &:focus-within,
      &:hover {
        background-color: ${grey100};
        border: 1px solid ${grey400};
      }
    }

    & .input {
      height: 100%;
      flex-grow: 2;
      border: none;
      background-color: transparent;

      ${getFontCss(
        14,
        themeConstants.colors.font_primary,
        styleConstants.fontFamilies.regular,
      )};

      &::placeholder {
        ${getFontCss(
          14,
          styleConstants.colors.gray_darkest,
          styleConstants.fontFamilies.regular,
        )};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    & .icon {
      margin-right: 14px;
    }
  }
`